export const SITE_URL =
    process.env.VUE_APP_SITE_URL || "http://localhost:8080/";
export const API_URL =
    process.env.VUE_APP_API_URL || "http://localhost:3000/v1/";
export const API_BASE_URL =
    process.env.VUE_APP_API_BASE_URL || "http://localhost:3000/";
export const ADMIN_BASE_URL =
    process.env.VUE_APP_ADMIN_BASE_URL || "http://localhost:8081/admin";
export default API_URL;
